import React from 'react';
import { useNavigate } from 'react-router-dom';
import SocialFooter from '../components/SocialFooter';
import { ArrowLeft, Heart, Target, TrendUp } from '@phosphor-icons/react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cardio-journey-app/artifacts/tyj7q2ct_logo%20365.png";
const BACKPACK_IMAGE = "https://customer-assets.emergentagent.com/job_cardio-journey-app/artifacts/dxanx88u_ChatGPT%20Image%20Mar%2026%2C%202026%2C%2002_14_19%20AM.png";
const PERSON_WRITING = "https://customer-assets.emergentagent.com/job_3088e77d-725d-4c0a-bf3e-16c63c18c94f/artifacts/r93r3aw3_8AB259E6-FC56-44F4-9673-EFD550914120.jpeg";

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background relative overflow-hidden" data-testid="about-screen">
      <div className="absolute top-0 left-0 right-0 h-[50%] opacity-[0.08] pointer-events-none" style={{ backgroundImage: `url(${LOGO_URL})`, backgroundPosition: 'center 10%', backgroundRepeat: 'no-repeat', backgroundSize: '45%' }} />

      <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-xl border-b border-border px-6 py-4">
        <div className="max-w-3xl mx-auto flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="w-10 h-10 rounded-full bg-card flex items-center justify-center" data-testid="back-btn">
            <ArrowLeft weight="bold" className="w-5 h-5 text-foreground" />
          </button>
          <img src={LOGO_URL} alt="Track365" className="w-40 h-auto" />
          <h1 className="text-xl font-bold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>About Track365 Cardio</h1>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-6 relative z-10">
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Left: All writing together */}
          <div className="flex-1">
            <p className="text-[#D4AF37] text-lg font-semibold tracking-wider mb-4 text-center lg:text-left">TRACK IT. BUILD IT. BECOME IT.</p>

            <div className="premium-card p-5 mb-3">
              <p className="text-base text-foreground leading-relaxed">
                Track365 Cardio was created for one simple reason — <strong className="text-[#D4AF37]">to help people stay consistent long enough to see real transformation.</strong>
              </p>
            </div>

            <p className="text-muted-foreground mb-3">
              Too many fitness apps focus on perfection. <span className="text-foreground">We focus on progress.</span>
            </p>

            <div className="premium-card p-5 mb-3">
              <p className="text-foreground leading-relaxed mb-2">Track365 is built around a powerful idea:</p>
              <p className="text-lg text-[#D4AF37] font-semibold italic">"If you show up every day and track your effort, your results will follow."</p>
            </div>

            <p className="text-muted-foreground text-sm mb-3">
              This isn't just a workout tracker. This is a 365-day commitment to becoming stronger, healthier, and more disciplined.
            </p>

            <div className="premium-card p-5 mb-3">
              <h3 className="text-sm text-[#D4AF37] uppercase tracking-wider font-semibold mb-3">We Believe</h3>
              <div className="space-y-2">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
                    <Heart weight="fill" className="w-4 h-4 text-[#D4AF37]" />
                  </div>
                  <p className="text-foreground text-sm">Consistency beats motivation</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
                    <Target weight="fill" className="w-4 h-4 text-[#D4AF37]" />
                  </div>
                  <p className="text-foreground text-sm">Small daily wins create big results</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
                    <TrendUp weight="fill" className="w-4 h-4 text-[#D4AF37]" />
                  </div>
                  <p className="text-foreground text-sm">Seeing your progress keeps you going</p>
                </div>
              </div>
            </div>

            <p className="text-foreground mb-1">Whether you're starting from day one or starting over,</p>
            <p className="text-[#D4AF37] text-lg font-bold mb-3">this is your space to build habits that last.</p>

            <div className="border-t border-border pt-3">
              <p className="text-xl font-black text-[#D4AF37] tracking-wider" style={{ fontFamily: 'Outfit, sans-serif' }}>TRACK IT. BUILD IT. BECOME IT.</p>
            </div>
          </div>

          {/* Right: 2 images horizontal, side by side, 70% smaller, full images no cutoff */}
          <div className="flex-shrink-0 flex flex-row lg:flex-col gap-2 lg:mt-6 max-w-[220px] mx-auto lg:mx-0">
            <div className="rounded-xl overflow-hidden shadow-md border border-[#D4AF37]/10">
              <img src={BACKPACK_IMAGE} alt="Track365 on the go" className="w-full h-auto object-contain" />
            </div>
            <div className="rounded-xl overflow-hidden shadow-md border border-[#D4AF37]/10">
              <img src={PERSON_WRITING} alt="Person tracking with Track365" className="w-full h-auto object-contain" />
            </div>
          </div>
        </div>

        <SocialFooter />
      </main>
    </div>
  );
};

export default About;
